module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "foreword",
      "id": "_idContainer005",
      "role": "doc-foreword"
    }
  }, [_c('p', {
    staticClass: "pl-epigraph"
  }, [_vm._v("Instead of shame and dishonor, you will enjoy a double share of honor. You will possess a double portion of prosperity in your land, and everlasting joy will be yours.")]), _vm._v(" "), _c('p', {
    staticClass: "pl-citation"
  }, [_vm._v("—"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Isaiah ")]), _vm._v("61:7")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-86393378","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Bible_Verse.vue
// module id = 72
// module chunks = 0